import _objectWithoutProperties from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
var _excluded = ["createApp"];
// 注册插件：
// import LoginPanel from "@tencent/vft-component/LoginPanel";
// Vue.use(LoginPanel, { pageUrl: 'https://film.qq.com' })
// 说明： pageUrl 是可选参数，默认是当前页面地址1

// 使用方法：
// 1. 调用双登录组件
// this.$openLogin({
//     jumpUrl: location.href,
//     // 可选：支持 app 下监听登录回调，便于异步刷新页面
//     onLogin: () => {
//         alert('登录成功')
//     }
// })
// 2. 直接拉起指定登录
// this.$switchLogin({
//     type: 'qq',
//     jumpUrl: location.href,
//     // 可选：支持 app 下监听登录回调，便于异步刷新页面
//     onLogin: () => {
//         alert('登录成功')
//     }
// })
// 说明：
// 也可以全局注册 window.reinit 的方法，用于登录成功后，统一调用该方法刷新页面数据

import vueCompat from '@tencent/vue-compat';
import LoginPanel from "./LoginPanel.vue";
export default {
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      createApp = _ref.createApp,
      options = _objectWithoutProperties(_ref, _excluded);
    var $el = document.createElement('div');
    document.body.appendChild($el);
    var isVue3 = vueCompat.isVue3(Vue);
    if (isVue3 && typeof createApp !== 'function') {
      throw new Error('options.createApp is required when used by vue3');
    }
    if (isVue3) {
      var instance = createApp(LoginPanel);
      instance.mount($el);
    } else {
      var _instance = new (Vue.extend(LoginPanel))();
      _instance.$mount($el);
    }
    LoginPanel.install(Vue, options);
  }
};